function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30.77,16.72a2.12,2.12,0,0,1-1.53,1.53V14.11A2.14,2.14,0,0,1,30.77,16.72Zm-2.95-4.24v7a2.5,2.5,0,0,1-2.5,2.5H6a2.5,2.5,0,0,1-2.5-2.5v-7A2.5,2.5,0,0,1,6,10H25.32A2.5,2.5,0,0,1,27.82,12.48Zm-1.5,0a1,1,0,0,0-1-1H6a1,1,0,0,0-1,1v7a1,1,0,0,0,1,1H25.32a1,1,0,0,0,1-1ZM10.49,13H7.9a1,1,0,0,0-1,1v4.17a1,1,0,0,0,1,1h2.59a1,1,0,0,0,1-1V14A1,1,0,0,0,10.49,13Z",
  fill: "#c67f7f"
});

var SvgBatteryLevel1Icon = function SvgBatteryLevel1Icon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 27,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBatteryLevel1Icon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/battery_level_1_icon.c76d2d13.svg";
export { ForwardRef as ReactComponent };